import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Avatar, Paper, Typography } from "@mui/material";

import AuthLayout from "../../layouts/Auth";

import SignInComponent from "../../components/auth/SignIn";
import LoginRedirect from "@aceso/components/auth/LoginRedirect";

import Logo from "../../../public/logo.svg";
import { Login } from "@mui/icons-material";
const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 64px;
  display: flex;
  height: 64px;
  margin-bottom: 32px;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) => props.theme.breakpoints.up("sm")} {
    padding: ${(props) => props.theme.spacing(10)};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  }

  ${(props) => props.theme.breakpoints.down("sm")} {
    height: 100vh;
    width: 100vw;
    justify-content: center;
  } ;
`;

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function SignIn() {
  return (
    <React.Fragment>
      <Wrapper>
        <Brand />
        <Helmet title="Sign In" />
        <BigAvatar alt="User" src="/static/img/avatars/avatar-0.png" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Velkommen!
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Logg inn for å fortsette
        </Typography>

        <LoginRedirect>
          <SignInComponent />
        </LoginRedirect>
      </Wrapper>
    </React.Fragment>
  );
}

SignIn.getLayout = function getLayout(page) {
  return <AuthLayout>{page}</AuthLayout>;
};

export default SignIn;
